export const PROFILE_STORE_KEY = "user";
